import React from 'react'
import { TouchableOpacity } from 'react-native'

import { Flex } from '../../../components/FlexBox'
import { Text } from '../../../components/common/Text'
import TrashIcon from '../../../components/icon/TrashIcon'
import SmallButton from './SmallButton'
import useTranslation from '../../../hooks/useTranslation'
import { IContentFeedBoost } from '../queries/getContentFeeds'
import ContentItemSummary from './ContentItemSummary'
import OpenInMi6Link from './OpenInMi6Link'
import { TableCol, TableRow } from './Table'

interface HeroSlotProps {
  /** 1-based position in the band, not the boost's stored rank. */
  position: number
  boost?: IContentFeedBoost
  onChoose: () => void
  onRemove: () => void
}

export const HeroSlot = ({
  position,
  boost,
  onChoose,
  onRemove
}: HeroSlotProps) => {
  const { t } = useTranslation()

  const label =
    position === 1
      ? t('contentCuration:hero:primary')
      : t('contentCuration:hero:slot', { rank: position })

  return (
    <TableRow>
      <TableCol style={{ maxWidth: 100, minWidth: 100 }}>
        <Text styles={{ fontWeight: '500' }}>{label}</Text>
      </TableCol>
      <TableCol style={{ minWidth: 240 }}>
        <ContentItemSummary
          item={boost?.item ?? null}
          emptyLabel={
            boost
              ? t('contentCuration:hero:unavailable')
              : t('contentCuration:hero:empty')
          }
        />
      </TableCol>
      <TableCol style={{ maxWidth: 246, minWidth: 226 }}>
        <Flex flexDirection="row" alignItems="center" justifyContent="flex-end">
          <SmallButton
            label={t('contentCuration:hero:choose')}
            onPress={onChoose}
          />
          <Flex ml={2}>
            <OpenInMi6Link boost={boost} />
          </Flex>
          {/* Present but inert on an empty slot rather than absent -- a control
              that appears and disappears is harder to read than one that is
              visibly unavailable. */}
          <TouchableOpacity
            onPress={onRemove}
            disabled={!boost}
            accessibilityLabel={t('contentCuration:detail:removeItem')}
            style={{ marginLeft: 8, opacity: boost ? 1 : 0.35 }}
          >
            <TrashIcon size={20} />
          </TouchableOpacity>
        </Flex>
      </TableCol>
    </TableRow>
  )
}

export default HeroSlot
